import React from 'react'
import styled from 'styled-components'

import CodeExampleContainer from '../CodeExampleContainer'
import CodeExample from '../CodeExample'

import { Heading2 } from '../../styles/Text'
import { Button } from '../../styles/Buttons'

const exampleContainer = [
  {
    primary: {
      heading: 'Pubsub',
      button_text: 'Learn more',
      button_link: {
        uid: 'channels',
        type: 'page',
        link_type: 'Document',
        url: '/channels',
      },
    },
    items: [
      {
        code_example: {
          document: {
            data: {
              main_heading: 'Publish',
              example: [
                {
                  heading: 'PHP',
                  code: {
                    richText: [
                      {
                        type: 'preformatted',
                        text: "pusher->trigger('my-channel', 'my-event', [\r\n  'message' => 'hello world'\r\n]);",
                        spans: [],
                      },
                    ],
                  },
                  button_text: null,
                  link: {
                    uid: null,
                    type: null,
                    link_type: 'Any',
                    url: null,
                  },
                },
                {
                  heading: 'Node',
                  code: {
                    richText: [
                      {
                        type: 'preformatted',
                        text: 'pusher.trigger(\'my-channel\', \'my-event\', {\r\n  "message": "hello world"\r\n});',
                        spans: [],
                      },
                    ],
                  },
                  button_text: null,
                  link: {
                    uid: null,
                    type: null,
                    link_type: 'Any',
                    url: null,
                  },
                },
                {
                  heading: 'Ruby',
                  code: {
                    richText: [
                      {
                        type: 'preformatted',
                        text: "pusher.trigger('my-channel', 'my-event', {\r\n  message: 'hello world'\r\n})",
                        spans: [],
                      },
                    ],
                  },
                  button_text: null,
                  link: {
                    uid: null,
                    type: null,
                    link_type: 'Any',
                    url: null,
                  },
                },
                {
                  heading: 'ASP',
                  code: {
                    richText: [
                      {
                        type: 'preformatted',
                        text: "pusher.Trigger('my-channel', 'my-event', new {\r\n  message = \"hello world\"\r\n});",
                        spans: [],
                      },
                    ],
                  },
                  button_text: null,
                  link: {
                    uid: null,
                    type: null,
                    link_type: 'Any',
                    url: null,
                  },
                },
                {
                  heading: 'Java',
                  code: {
                    richText: [
                      {
                        type: 'preformatted',
                        text: 'pusher.trigger("my-channel", "my-event", Collections.singletonMap("message", "hello world"));',
                        spans: [],
                      },
                    ],
                  },
                  button_text: null,
                  link: {
                    uid: null,
                    type: null,
                    link_type: 'Any',
                    url: null,
                  },
                },
                {
                  heading: 'Python',
                  code: {
                    richText: [
                      {
                        type: 'preformatted',
                        text: "pusher.trigger('my-channel', 'my-event', {\r\n  'message': 'hello world'\r\n})",
                        spans: [],
                      },
                    ],
                  },
                  button_text: null,
                  link: {
                    uid: null,
                    type: null,
                    link_type: 'Any',
                    url: null,
                  },
                },
                {
                  heading: 'Go',
                  code: {
                    richText: [
                      {
                        type: 'preformatted',
                        text: 'pusher.Trigger("my-channel", "my-event", map[string]string{\r\n  "message": "hello world",\r\n})',
                        spans: [],
                      },
                    ],
                  },
                  button_text: null,
                  link: {
                    uid: null,
                    type: null,
                    link_type: 'Any',
                    url: null,
                  },
                },
              ],
            },
          },
        },
      },
      {
        code_example: {
          document: {
            data: {
              main_heading: 'Subscribe',
              example: [
                {
                  heading: 'JS',
                  code: {
                    richText: [
                      {
                        type: 'preformatted',
                        text: "var channel = pusher.subscribe('my-channel');\r\nchannel.bind('my-event', function(data) {\r\n  alert('Received my-event with message: ' + data.message);\r\n});",
                        spans: [],
                      },
                    ],
                  },
                  button_text: null,
                  link: {
                    uid: null,
                    type: null,
                    link_type: 'Any',
                    url: null,
                  },
                },
                {
                  heading: 'Android',
                  code: {
                    richText: [
                      {
                        type: 'preformatted',
                        text: 'Channel channel = pusher.subscribe("my-channel");\r\nchannel.bind("my-event", new SubscriptionEventListener() {\r\n  @Override\r\n  public void onEvent(String channel, String event, String data) {\r\n    System.put.println("Received event with data: " + data);\r\n  }\r\n});',
                        spans: [],
                      },
                    ],
                  },
                  button_text: null,
                  link: {
                    uid: null,
                    type: null,
                    link_type: 'Any',
                    url: null,
                  },
                },
                {
                  heading: 'iOS (Swift)',
                  code: {
                    richText: [
                      {
                        type: 'preformatted',
                        text: 'let channel = pusher.subscribe("my-channel")\n\nchannel.bind(eventName: "my-event", callback: { (optionalData: Any?) -> Void in\r\n  if let data = optionalData {\r\n      print("Received event with data: \\(data)")\r\n  }\r\n})',
                        spans: [],
                      },
                    ],
                  },
                  button_text: null,
                  link: {
                    uid: null,
                    type: null,
                    link_type: 'Any',
                    url: null,
                  },
                },
                {
                  heading: 'iOS (Obj-C)',
                  code: {
                    richText: [
                      {
                        type: 'preformatted',
                        text: 'PusherChannel *channel = [pusher subscribeWithChannelName:@"my-channel"];\n\n[channel bindWithEventName:@"my-event" callback:^void (NSDictionary *data) {\r\n    NSString *message = data[@"message"];\r\n    NSLog(@"message received: %@", message);\r\n}];',
                        spans: [],
                      },
                    ],
                  },
                  button_text: null,
                  link: {
                    uid: null,
                    type: null,
                    link_type: 'Any',
                    url: null,
                  },
                },
              ],
            },
          },
        },
      },
    ],
  },
  {
    primary: {
      heading: 'Notifications',
      button_text: 'Learn more',
      button_link: {
        uid: 'beams',
        type: 'page',
        link_type: 'Document',
        url: '/beams',
      },
    },
    items: [
      {
        code_example: {
          document: {
            data: {
              main_heading: 'Publish API',
              example: [
                {
                  heading: 'Node.JS',
                  code: {
                    richText: [
                      {
                        type: 'preformatted',
                        text: "const beamsClient = new PushNotifications({\r\n  instanceId: 'YOUR_INSTANCE_ID_HERE',\r\n  secretKey: 'YOUR_SECRET_KEY_HERE'\r\n});\n\nbeamsClient.publishToInterests(['hello'], {\r\n  apns: {\r\n    aps: {\r\n      alert: 'Hello!'\r\n    }\r\n  },\r\n  fcm: {\r\n    notification: {\r\n      title: 'Hello',\r\n      body: 'Hello, world!'\r\n    }\r\n  }\r\n}).then((publishResponse) => {\r\n  console.log('Just published:', publishResponse.publishId);\r\n}).catch((error) => {\r\n  console.error('Error:', error);\r\n});",
                        spans: [],
                      },
                    ],
                  },
                  button_text: null,
                  link: {
                    uid: null,
                    type: null,
                    link_type: 'Any',
                    url: null,
                  },
                },
                {
                  heading: 'Go',
                  code: {
                    richText: [
                      {
                        type: 'preformatted',
                        text: 'const (\r\n  instanceId = "YOUR_INSTANCE_ID_HERE"\r\n  secretKey  = "YOUR_SECRET_KEY_HERE"\r\n)\n\nbeamsClient := pushnotifications.New(instanceId, secretKey)\n\npublishRequest := map[string]interface{}{\r\n  "apns": map[string]interface{}{\r\n    "aps": map[string]interface{}{\r\n      "alert": map[string]interface{}{\r\n        "title": "Hello",\r\n        "body":  "Hello, world",\r\n      },\r\n    },\r\n  },\r\n  "fcm": map[string]interface{}{\r\n    "notification": map[string]interface{}{\r\n      "title": "Hello",\r\n      "body":  "Hello, world",\r\n    },\r\n  },\r\n}\n\npubId, err := beamsClient.PublishToInterests([]string{"hello"}, publishRequest)\r\nif err != nil {\r\n  fmt.Println(err)\r\n} else {\r\n  fmt.Println("Publish Id:", pubId)\r\n}',
                        spans: [],
                      },
                    ],
                  },
                  button_text: null,
                  link: {
                    uid: null,
                    type: null,
                    link_type: 'Any',
                    url: null,
                  },
                },
                {
                  heading: 'Python',
                  code: {
                    richText: [
                      {
                        type: 'preformatted',
                        text: "beams_client = PushNotifications(\r\n  instance_id='YOUR_INSTANCE_ID_HERE',\r\n  secret_key='YOUR_SECRET_KEY_HERE',\r\n)\n\nresponse = beams_client.publish_to_interests(\r\n  interests=['hello'],\r\n  publish_body={\r\n    'apns': {\r\n      'aps': {\r\n        'alert': 'Hello!',\r\n      },\r\n    },\r\n    'fcm': {\r\n      'notification': {\r\n        'title': 'Hello',\r\n        'body': 'Hello, world!',\r\n      },\r\n    },\r\n  },\r\n)\n\nprint(response['publishId'])",
                        spans: [],
                      },
                    ],
                  },
                  button_text: null,
                  link: {
                    uid: null,
                    type: null,
                    link_type: 'Any',
                    url: null,
                  },
                },
                {
                  heading: 'Java',
                  code: {
                    richText: [
                      {
                        type: 'preformatted',
                        text: 'String instanceId = "YOUR_INSTANCE_ID_HERE";\r\nString secretKey = "YOUR_SECRET_KEY_HERE";\n\nPushNotifications beamsClient = new PushNotifications(instanceId, secretKey);\n\nList<String> interests = Arrays.asList("donuts", "pizza");\n\nMap<String, Map> publishRequest = new HashMap();\n\nMap<String, String> alert = new HashMap();\r\nalert.put("alert", "hi");\r\nMap<String, Map> aps = new HashMap();\r\naps.put("aps", alert);\r\npublishRequest.put("apns", aps);\n\nMap<String, String> fcmNotification = new HashMap();\r\nfcmNotification.put("title", "hello");\r\nfcmNotification.put("body", "Hello world");\r\nMap<String, Map> fcm = new HashMap();\r\nfcm.put("notification", fcmNotification);\r\npublishRequest.put("fcm", fcm);\n\nbeamsClient.publishToInterests(interests, publishRequest);',
                        spans: [],
                      },
                    ],
                  },
                  button_text: null,
                  link: {
                    uid: null,
                    type: null,
                    link_type: 'Any',
                    url: null,
                  },
                },
                {
                  heading: 'Kotlin',
                  code: {
                    richText: [
                      {
                        type: 'preformatted',
                        text: 'val instanceId = "YOUR_INSTANCE_ID_HERE"\r\nval secretKey = "YOUR_SECRET_KEY_HERE"\n\nval beamsClient = PushNotifications(instanceId, secretKey)\n\nval interests = listOf("donuts", "pizza")\r\nval publishRequest = hashMapOf(\r\n  "apns" to hashMapOf("aps" to hashMapOf("alert" to "hi")),\r\n  "fcm" to hashMapOf("notification" to hashMapOf("title" to "hello", "body" to "Hello world"))\r\n)\n\nbeamsClient.publishToInterests(interests, publishRequest)',
                        spans: [],
                      },
                    ],
                  },
                  button_text: null,
                  link: {
                    uid: null,
                    type: null,
                    link_type: 'Any',
                    url: null,
                  },
                },
                {
                  heading: 'Ruby',
                  code: {
                    richText: [
                      {
                        type: 'preformatted',
                        text: "Pusher::PushNotifications.configure do |config|\r\n  config.instance_id = 'YOUR_INSTANCE_ID_HERE'\r\n  config.secret_key = 'YOUR_SECRET_KEY_HERE'\r\nend\n\ndata = {\r\n  apns: {\r\n    aps: {\r\n      alert: {\r\n        title: 'Hello',\r\n        body: 'Hello, world!'\r\n      }\r\n    }\r\n  },\r\n  fcm: {\r\n    notification: {\r\n      title: 'Hello',\r\n      body: 'Hello, world!'\r\n    }\r\n  }\r\n}\n\nPusher::PushNotifications.publishToInterests(interests: ['hello'], payload: data)",
                        spans: [],
                      },
                    ],
                  },
                  button_text: null,
                  link: {
                    uid: null,
                    type: null,
                    link_type: 'Any',
                    url: null,
                  },
                },
              ],
            },
          },
        },
      },
    ],
  },
]

const formattedExamples = [
  {
    main_heading: 'Publish',
    example: [
      {
        heading: 'PHP',
        code: [
          'pusher-&gt;trigger(<span class="hljs-string">&#x27;my-channel&#x27;</span>, <span class="hljs-string">&#x27;my-event&#x27;</span>, [\r',
          '  <span class="hljs-string">&#x27;message&#x27;</span> =&gt; <span class="hljs-string">&#x27;hello world&#x27;</span>\r',
          ']);',
        ],
      },
      {
        heading: 'Node',
        code: [
          'pusher.<span class="hljs-title function_">trigger</span>(<span class="hljs-string">&#x27;my-channel&#x27;</span>, <span class="hljs-string">&#x27;my-event&#x27;</span>, {\r',
          '  <span class="hljs-string">&quot;message&quot;</span>: <span class="hljs-string">&quot;hello world&quot;</span>\r',
          '});',
        ],
      },
      {
        heading: 'Ruby',
        code: [
          'pusher.<span class="hljs-title function_">trigger</span>(<span class="hljs-string">&#x27;my-channel&#x27;</span>, <span class="hljs-string">&#x27;my-event&#x27;</span>, {\r',
          '  <span class="hljs-attr">message</span>: <span class="hljs-string">&#x27;hello world&#x27;</span>\r',
          '})',
        ],
      },
      {
        heading: 'ASP',
        code: [
          'pusher.<span class="hljs-title class_">Trigger</span>(<span class="hljs-string">&#x27;my-channel&#x27;</span>, <span class="hljs-string">&#x27;my-event&#x27;</span>, <span class="hljs-keyword">new</span> {\r',
          '  message = <span class="hljs-string">&quot;hello world&quot;</span>\r',
          '});',
        ],
      },
      {
        heading: 'Java',
        code: [
          'pusher.<span class="hljs-title function_">trigger</span>(<span class="hljs-string">&quot;my-channel&quot;</span>, <span class="hljs-string">&quot;my-event&quot;</span>, <span class="hljs-title class_">Collections</span>.<span class="hljs-title function_">singletonMap</span>(<span class="hljs-string">&quot;message&quot;</span>, <span class="hljs-string">&quot;hello world&quot;</span>));',
        ],
      },
      {
        heading: 'Python',
        code: [
          'pusher.<span class="hljs-title function_">trigger</span>(<span class="hljs-string">&#x27;my-channel&#x27;</span>, <span class="hljs-string">&#x27;my-event&#x27;</span>, {\r',
          '  <span class="hljs-string">&#x27;message&#x27;</span>: <span class="hljs-string">&#x27;hello world&#x27;</span>\r',
          '})',
        ],
      },
      {
        heading: 'Go',
        code: [
          'pusher.Trigger(<span class="hljs-string">&quot;my-channel&quot;</span>, <span class="hljs-string">&quot;my-event&quot;</span>, map[<span class="hljs-built_in">string</span>]<span class="hljs-built_in">string</span>{\r',
          '  <span class="hljs-string">&quot;message&quot;</span>: <span class="hljs-string">&quot;hello world&quot;</span>,\r',
          '})',
        ],
      },
    ],
  },
  {
    main_heading: 'Subscribe',
    example: [
      {
        heading: 'JS',
        code: [
          '<span class="hljs-keyword">var</span> channel = pusher.<span class="hljs-title function_">subscribe</span>(<span class="hljs-string">&#x27;my-channel&#x27;</span>);\r',
          'channel.<span class="hljs-title function_">bind</span>(<span class="hljs-string">&#x27;my-event&#x27;</span>, <span class="hljs-keyword">function</span>(<span class="hljs-params">data</span>) {\r',
          '  alert(<span class="hljs-string">&#x27;Received my-event with message: &#x27;</span> + <span class="hljs-keyword">data</span>.message);\r',
          '});',
        ],
      },
      {
        heading: 'Android',
        code: [
          '<span class="hljs-title class_">Channel</span> channel = pusher.<span class="hljs-title function_">subscribe</span>(<span class="hljs-string">&quot;my-channel&quot;</span>);\r',
          'channel.<span class="hljs-title function_">bind</span>(<span class="hljs-string">&quot;my-event&quot;</span>, <span class="hljs-keyword">new</span> <span class="hljs-title class_">SubscriptionEventListener</span>() {\r',
          '  <span class="hljs-meta">@Override</span>\r',
          '  public <span class="hljs-keyword">void</span> <span class="hljs-title function_">onEvent</span>(<span class="hljs-params"><span class="hljs-built_in">String</span> channel, <span class="hljs-built_in">String</span> event, <span class="hljs-built_in">String</span> data</span>) {\r',
          '    System.put.println(<span class="hljs-string">&quot;Received event with data: &quot;</span> + <span class="hljs-keyword">data</span>);\r',
          '  }\r',
          '});',
        ],
      },
      {
        heading: 'iOS (Swift)',
        code: [
          '<span class="hljs-keyword">let</span> channel = pusher.<span class="hljs-title function_">subscribe</span>(<span class="hljs-string">&quot;my-channel&quot;</span>)',
          '',
          'channel.bind(eventName: <span class="hljs-string">&quot;my-event&quot;</span>, callback: { (optionalData: Any?) -&gt; <span class="hljs-built_in">Void</span> <span class="hljs-keyword">in</span>\r',
          '  <span class="hljs-keyword">if</span> <span class="hljs-keyword">let</span> data = optionalData {\r',
          '      <span class="hljs-built_in">print</span>(<span class="hljs-string">&quot;Received event with data: <span class="hljs-subst">\\(data)</span>&quot;</span>)\r',
          '  }\r',
          '})',
        ],
      },
      {
        heading: 'iOS (Obj-C)',
        code: [
          '<span class="hljs-title class_">PusherChannel</span> *channel = [pusher <span class="hljs-attr">subscribeWithChannelName</span>:@<span class="hljs-string">&quot;my-channel&quot;</span>];',
          '',
          '[channel bindWithEventName:<span class="hljs-string">@&quot;my-event&quot;</span> callback:^<span class="hljs-keyword">void</span> (<span class="hljs-built_in">NSDictionary</span> *data) {\r',
          '    NSString *message = <span class="hljs-keyword">data</span>[@<span class="hljs-string">&quot;message&quot;</span>];\r',
          '    <span class="hljs-type">NSLog</span>(@<span class="hljs-string">&quot;message received: %@&quot;</span>, message);\r',
          '}];',
        ],
      },
    ],
  },
  {
    main_heading: 'Publish API',
    example: [
      {
        heading: 'Node.JS',
        code: [
          '<span class="hljs-keyword">const</span> beamsClient = <span class="hljs-keyword">new</span> <span class="hljs-title class_">PushNotifications</span>({\r',
          '  <span class="hljs-attr">instanceId</span>: <span class="hljs-string">&#x27;YOUR_INSTANCE_ID_HERE&#x27;</span>,\r',
          '  <span class="hljs-attr">secretKey</span>: <span class="hljs-string">&#x27;YOUR_SECRET_KEY_HERE&#x27;</span>\r',
          '});',
          '',
          'beamsClient.<span class="hljs-title function_">publishToInterests</span>([<span class="hljs-string">&#x27;hello&#x27;</span>], {\r',
          '  apns: {\r',
          '    aps: {\r',
          '      <span class="hljs-attr">alert</span>: <span class="hljs-string">&#x27;Hello!&#x27;</span>\r',
          '    }\r',
          '  },\r',
          '  fcm: {\r',
          '    notification: {\r',
          '      <span class="hljs-attr">title</span>: <span class="hljs-string">&#x27;Hello&#x27;</span>,\r',
          '      <span class="hljs-attr">body</span>: <span class="hljs-string">&#x27;Hello, world!&#x27;</span>\r',
          '    }\r',
          '  }\r',
          '}).<span class="hljs-title function_">then</span>(<span class="hljs-function">(<span class="hljs-params">publishResponse</span>) =&gt;</span> {\r',
          '  <span class="hljs-variable language_">console</span>.<span class="hljs-title function_">log</span>(<span class="hljs-string">&#x27;Just published:&#x27;</span>, publishResponse.<span class="hljs-property">publishId</span>);\r',
          '}).<span class="hljs-title function_">catch</span>(<span class="hljs-function">(<span class="hljs-params">error</span>) =&gt;</span> {\r',
          '  <span class="hljs-variable language_">console</span>.<span class="hljs-title function_">error</span>(<span class="hljs-string">&#x27;Error:&#x27;</span>, error);\r',
          '});',
        ],
      },
      {
        heading: 'Go',
        code: [
          '<span class="hljs-keyword">const</span> (\r',
          '  instanceId = <span class="hljs-string">&quot;YOUR_INSTANCE_ID_HERE&quot;</span>\r',
          '  secretKey  = <span class="hljs-string">&quot;YOUR_SECRET_KEY_HERE&quot;</span>\r',
          ')',
          '',
          'beamsClient := pushnotifications.<span class="hljs-keyword">New</span>(instanceId, secretKey)',
          '',
          'publishRequest := map[<span class="hljs-built_in">string</span>]<span class="hljs-keyword">interface</span>{}{\r',
          '  <span class="hljs-string">&quot;apns&quot;</span>: map[<span class="hljs-built_in">string</span>]<span class="hljs-keyword">interface</span>{}{\r',
          '    <span class="hljs-string">&quot;aps&quot;</span>: map[<span class="hljs-built_in">string</span>]<span class="hljs-keyword">interface</span>{}{\r',
          '      <span class="hljs-string">&quot;alert&quot;</span>: map[<span class="hljs-built_in">string</span>]<span class="hljs-keyword">interface</span>{}{\r',
          '        <span class="hljs-string">&quot;title&quot;</span>: <span class="hljs-string">&quot;Hello&quot;</span>,\r',
          '        <span class="hljs-string">&quot;body&quot;</span>:  <span class="hljs-string">&quot;Hello, world&quot;</span>,\r',
          '      },\r',
          '    },\r',
          '  },\r',
          '  <span class="hljs-string">&quot;fcm&quot;</span>: map[<span class="hljs-built_in">string</span>]<span class="hljs-keyword">interface</span>{}{\r',
          '    <span class="hljs-string">&quot;notification&quot;</span>: map[<span class="hljs-built_in">string</span>]<span class="hljs-keyword">interface</span>{}{\r',
          '      <span class="hljs-string">&quot;title&quot;</span>: <span class="hljs-string">&quot;Hello&quot;</span>,\r',
          '      <span class="hljs-string">&quot;body&quot;</span>:  <span class="hljs-string">&quot;Hello, world&quot;</span>,\r',
          '    },\r',
          '  },\r',
          '}',
          '',
          'pubId, err := beamsClient.PublishToInterests([]<span class="hljs-built_in">string</span>{<span class="hljs-string">&quot;hello&quot;</span>}, publishRequest)\r',
          '<span class="hljs-keyword">if</span> err <span class="hljs-operator">!=</span> <span class="hljs-literal">nil</span> {\r',
          '  fmt.Println(err)\r',
          '} <span class="hljs-keyword">else</span> {\r',
          '  fmt.<span class="hljs-title class_">Println</span>(<span class="hljs-string">&quot;Publish Id:&quot;</span>, pubId)\r',
          '}',
        ],
      },
      {
        heading: 'Python',
        code: [
          'beams_client = PushNotifications(\r',
          '  instance_id=<span class="hljs-string">&#x27;YOUR_INSTANCE_ID_HERE&#x27;</span>,\r',
          '  secret_key=<span class="hljs-string">&#x27;YOUR_SECRET_KEY_HERE&#x27;</span>,\r',
          ')',
          '',
          'response = beams_client.publish_to_interests(\r',
          '  interests=[<span class="hljs-string">&#x27;hello&#x27;</span>],\r',
          '  publish_body={\r',
          '    <span class="hljs-string">&#x27;apns&#x27;</span>: {\r',
          '      <span class="hljs-string">&#x27;aps&#x27;</span>: {\r',
          '        <span class="hljs-string">&#x27;alert&#x27;</span>: <span class="hljs-string">&#x27;Hello!&#x27;</span>,\r',
          '      },\r',
          '    },\r',
          '    <span class="hljs-string">&#x27;fcm&#x27;</span>: {\r',
          '      <span class="hljs-string">&#x27;notification&#x27;</span>: {\r',
          '        <span class="hljs-string">&#x27;title&#x27;</span>: <span class="hljs-string">&#x27;Hello&#x27;</span>,\r',
          '        <span class="hljs-string">&#x27;body&#x27;</span>: <span class="hljs-string">&#x27;Hello, world!&#x27;</span>,\r',
          '      },\r',
          '    },\r',
          '  },\r',
          ')',
          '',
          '<span class="hljs-keyword">print</span>(response[<span class="hljs-string">&#x27;publishId&#x27;</span>])',
        ],
      },
      {
        heading: 'Java',
        code: [
          '<span class="hljs-title class_">String</span> instanceId = <span class="hljs-string">&quot;YOUR_INSTANCE_ID_HERE&quot;</span>;\r',
          '<span class="hljs-title class_">String</span> secretKey = <span class="hljs-string">&quot;YOUR_SECRET_KEY_HERE&quot;</span>;',
          '',
          '<span class="hljs-title class_">PushNotifications</span> beamsClient = <span class="hljs-keyword">new</span> <span class="hljs-title class_">PushNotifications</span>(instanceId, secretKey);',
          '',
          '<span class="hljs-title class_">List</span>&lt;<span class="hljs-title class_">String</span>&gt; interests = <span class="hljs-title class_">Arrays</span>.<span class="hljs-title function_">asList</span>(<span class="hljs-string">&quot;donuts&quot;</span>, <span class="hljs-string">&quot;pizza&quot;</span>);',
          '',
          '<span class="hljs-title class_">Map</span>&lt;<span class="hljs-title class_">String</span>, <span class="hljs-title class_">Map</span>&gt; publishRequest = <span class="hljs-keyword">new</span> <span class="hljs-title class_">HashMap</span>();',
          '',
          '<span class="hljs-title class_">Map</span>&lt;<span class="hljs-title class_">String</span>, <span class="hljs-title class_">String</span>&gt; alert = <span class="hljs-keyword">new</span> <span class="hljs-title class_">HashMap</span>();\r',
          'alert.<span class="hljs-title function_">put</span>(<span class="hljs-string">&quot;alert&quot;</span>, <span class="hljs-string">&quot;hi&quot;</span>);\r',
          '<span class="hljs-title class_">Map</span>&lt;<span class="hljs-title class_">String</span>, <span class="hljs-title class_">Map</span>&gt; aps = <span class="hljs-keyword">new</span> <span class="hljs-title class_">HashMap</span>();\r',
          'aps.<span class="hljs-title function_">put</span>(<span class="hljs-string">&quot;aps&quot;</span>, alert);\r',
          'publishRequest.<span class="hljs-title function_">put</span>(<span class="hljs-string">&quot;apns&quot;</span>, aps);',
          '',
          '<span class="hljs-title class_">Map</span>&lt;<span class="hljs-title class_">String</span>, <span class="hljs-title class_">String</span>&gt; fcmNotification = <span class="hljs-keyword">new</span> <span class="hljs-title class_">HashMap</span>();\r',
          'fcmNotification.<span class="hljs-title function_">put</span>(<span class="hljs-string">&quot;title&quot;</span>, <span class="hljs-string">&quot;hello&quot;</span>);\r',
          'fcmNotification.<span class="hljs-title function_">put</span>(<span class="hljs-string">&quot;body&quot;</span>, <span class="hljs-string">&quot;Hello world&quot;</span>);\r',
          '<span class="hljs-title class_">Map</span>&lt;<span class="hljs-title class_">String</span>, <span class="hljs-title class_">Map</span>&gt; fcm = <span class="hljs-keyword">new</span> <span class="hljs-title class_">HashMap</span>();\r',
          'fcm.<span class="hljs-title function_">put</span>(<span class="hljs-string">&quot;notification&quot;</span>, fcmNotification);\r',
          'publishRequest.<span class="hljs-title function_">put</span>(<span class="hljs-string">&quot;fcm&quot;</span>, fcm);',
          '',
          'beamsClient.publishToInterests(interests, publishRequest);',
        ],
      },
      {
        heading: 'Kotlin',
        code: [
          '<span class="hljs-keyword">val</span> instanceId = <span class="hljs-string">&quot;YOUR_INSTANCE_ID_HERE&quot;</span>\r',
          '<span class="hljs-keyword">val</span> secretKey = <span class="hljs-string">&quot;YOUR_SECRET_KEY_HERE&quot;</span>',
          '',
          '<span class="hljs-keyword">val</span> beamsClient = PushNotifications(instanceId, secretKey)',
          '',
          '<span class="hljs-keyword">val</span> interests = listOf(<span class="hljs-string">&quot;donuts&quot;</span>, <span class="hljs-string">&quot;pizza&quot;</span>)\r',
          '<span class="hljs-keyword">val</span> publishRequest = hashMapOf(\r',
          '  <span class="hljs-string">&quot;apns&quot;</span> to <span class="hljs-title function_">hashMapOf</span>(<span class="hljs-string">&quot;aps&quot;</span> to <span class="hljs-title function_">hashMapOf</span>(<span class="hljs-string">&quot;alert&quot;</span> to <span class="hljs-string">&quot;hi&quot;</span>)),\r',
          '  <span class="hljs-string">&quot;fcm&quot;</span> to <span class="hljs-title function_">hashMapOf</span>(<span class="hljs-string">&quot;notification&quot;</span> to <span class="hljs-title function_">hashMapOf</span>(<span class="hljs-string">&quot;title&quot;</span> to <span class="hljs-string">&quot;hello&quot;</span>, <span class="hljs-string">&quot;body&quot;</span> to <span class="hljs-string">&quot;Hello world&quot;</span>))\r',
          ')',
          '',
          'beamsClient.publishToInterests(interests, publishRequest)',
        ],
      },
      {
        heading: 'Ruby',
        code: [
          'Pusher::PushNotifications.configure <span class="hljs-keyword">do</span> |config|\r',
          '  config.<span class="hljs-property">instance_id</span> = <span class="hljs-string">&#x27;YOUR_INSTANCE_ID_HERE&#x27;</span>\r',
          '  config.<span class="hljs-property">secret_key</span> = <span class="hljs-string">&#x27;YOUR_SECRET_KEY_HERE&#x27;</span>\r',
          '<span class="hljs-keyword">end</span>',
          '',
          '<span class="hljs-keyword">data</span> = {\r',
          '  apns: {\r',
          '    aps: {\r',
          '      alert: {\r',
          '        <span class="hljs-attr">title</span>: <span class="hljs-string">&#x27;Hello&#x27;</span>,\r',
          '        <span class="hljs-attr">body</span>: <span class="hljs-string">&#x27;Hello, world!&#x27;</span>\r',
          '      }\r',
          '    }\r',
          '  },\r',
          '  fcm: {\r',
          '    notification: {\r',
          '      <span class="hljs-attr">title</span>: <span class="hljs-string">&#x27;Hello&#x27;</span>,\r',
          '      <span class="hljs-attr">body</span>: <span class="hljs-string">&#x27;Hello, world!&#x27;</span>\r',
          '    }\r',
          '  }\r',
          '}',
          '',
          'Pusher::PushNotifications.publishToInterests(interests: [<span class="hljs-string">&#x27;hello&#x27;</span>], payload: <span class="hljs-keyword">data</span>)',
        ],
      },
    ],
  },
]

const Heading = styled(Heading2)`
  margin-bottom: 32px;
`

const CodeExampleWrapper = styled.div`
  margin-bottom: 48px;
  > div {
    margin: 0;
    max-width: 528px;
    height: initial;
  }
`

const CodeWrapper = styled.div`
  position: relative;
  min-height: 352px;
  background-color: #1a1c25;
  border-radius: 6px;
  @media (min-width: ${(p) => p.theme.breakpointMd}) {
    height: 100%;
  }
`

const Code = styled.div`
  padding: 16px;
  flex-grow: 1;
  overflow: auto;
  color: white;
  display: flex;
  flex-direction: column;
  @media (min-width: ${(p) => p.theme.breakpointMd}) {
    scrollbar-width: none;
    -ms-overflow-style: none;
    ::-webkit-scrollbar {
      width: 0;
      height: 0;
    }
    height: 100%;
  }
`

const CodeInnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`

const CodeInner = styled.div`
  font-family: 'Maison Neue Mono', sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  span {
    color: #bfb1ff;
    :hover {
      background-color: ${(p) => p.theme.purple};
      color: white;
    }
    :focus {
      background-color: transparent;
      color: #bfb1ff;
      outline: 1px solid ${(p) => p.theme.purple};
    }
  }
`

const CodeButtonWrapper = styled.div`
  display: flex;
  margin-top: auto;
  padding-top: 24px;
  button:first-child {
    margin-right: 16px;
  }
`

const CustomButton = styled(Button)`
  padding: 4px 12px;
`

const CodeBlock = () => {
  return (
    <>
      <Heading>Code blocks</Heading>
      <CodeExampleWrapper>
        <CodeExampleContainer exampleContainer={exampleContainer} formattedExamples={formattedExamples} />
      </CodeExampleWrapper>
      <CodeExampleWrapper>
        <CodeExample
          examples={exampleContainer?.[0]?.items?.[0]?.code_example?.document?.data?.example}
          heading="Publish"
          formattedExamples={formattedExamples?.[0]}
        />
      </CodeExampleWrapper>
      <CodeExampleWrapper>
        <CodeExample
          examples={exampleContainer?.[0]?.items?.[1]?.code_example?.document?.data?.example}
          heading="Subscribe"
          formattedExamples={formattedExamples?.[1]}
        />
      </CodeExampleWrapper>
      <CodeExampleWrapper>
        <CodeWrapper>
          <Code>
            <CodeInnerWrapper>
              <CodeInner
                beamsEnabled={false}
                id="code"
                dangerouslySetInnerHTML={{
                  __html: `
<pre>curl -X POST "https://curl-demo-beams-web-push.herokuapp.com/api/publish" \\
      -H "Authorization: Bearer 55870735993ea6e532d0ce32de476f92d3e6dcbba14bf67fa4ed871e66239a79" \\
      -H "Content-Type: application/json" \\
      -d '{
        "users": ["7"],
        "web": {
          "notification": {
            "title": "Your pizza is on the way!",
            "body": "Hold tight. We’ll let you know when yur delivery driver is nearby."
          }
        }
      }'</pre>
                        `,
                }}
              />
              <CodeButtonWrapper>
                <CustomButton reversedWhite textColor="#300D4F">
                  Send Notification
                </CustomButton>
                <CustomButton reversedWhite textColor="#300D4F">
                  Copy cURL request
                </CustomButton>
              </CodeButtonWrapper>
            </CodeInnerWrapper>
          </Code>
        </CodeWrapper>
      </CodeExampleWrapper>
    </>
  )
}

export default CodeBlock
